/* @flow */

import React, { Fragment } from 'react'
import TextInput from 'atpjs/components/form/input'
import Radio from 'atpjs/components/form/radio'
import NavigationButtons from 'atpjs/components/navigation_buttons'
import i18n from 'atpjs/helpers/i18n'
import { withMessageFn, predicate } from 'atpjs/validation/functions'
import { boolean, isEmpty, isExisty, reportError } from 'atpjs/validation/validators'
import { getClient } from 'tve/api/atp'
import Application from 'tve/components/application'
import { BigOptionRadio } from 'tve/components/forms/big_option'
import IbanInput from 'tve/components/forms/iban'
import Navigation from 'tve/components/navigation'
import Step from 'tve/views/step'
import { VALIDATION } from 'tve/config/other'

// Kunden-Nr.,Konto-Nr.,IBAN-Nr.,Kunden-Haupttyp,Kundenberater,Kundenberater E-Mail
// 148021.15,148021-8556,CH0500785001480218556,Private Einzelperson,Team Kundenservice,
// 148021.15,148021-2292,CH6200785001480212292,Private Einzelperson,Team Kundenservice,
// 148024.09,148024-7846,CH1600785001480247846,Private Einzelperson,Team Kundenservice,
// 148025.07,148025-8446,CH6300785001480258446,Mehrere Privatpersonen,Team Kundenservice,
// 100189.3,704278-61,CH6800785000070427861,Firmen und sonstige,Team Kundenservice,
// 100189.3,721146-93,CH1400785000072114693,Firmen und sonstige,Team Kundenservice,
// 100189.3,750254.83,CH2400785000075025483,Firmen und sonstige,Team Kundenservice,
// 100189.3,752887.32,CH7300785000075288732,Firmen und sonstige,Team Kundenservice,
// 100189.3,720680-76,CH9800785000072068076,Firmen und sonstige,Team Kundenservice,
// 100189.3,709536-46,CH1700785000070953646,Firmen und sonstige,Team Kundenservice,
// 100189.3,709535-48,CH4400785000070953548,Firmen und sonstige,Team Kundenservice,
// 100195.33,800544-91,CH2700785000080054491,Firmen und sonstige, Team Auslandkunden,
// 100198.27,100198-1301,CH4800785001001981301,Firmen und sonstige, Team KMU,
// 100198.27,100198-0110,CH9800785001001980110,Firmen und sonstige, Team KMU,
// 100206.73,100206-0264,CH1000785001002060264,Firmen und sonstige,Team Kundenservice,
// 100206.73,100206-0460,CH5300785001002060460,Firmen und sonstige,Team Kundenservice,
// 100208.69,807466.38,CH7800785000080746638,Firmen und sonstige, Team Anlegen,
// 100209.67,750420.01,CH4400785000075042001,Firmen und sonstige, Team Anlegen,
// 100214.72,100214-9415,CH8500785001002149415,Firmen und sonstige,Jennifer Schuler,ukb+finanzieren.berater@atpoint.local
// 100214.72,803615.83,CH0600785000080361583,Firmen und sonstige,Jennifer Schuler,ukb+finanzieren.berater@atpoint.local
// 100214.72,832000.11,CH1600785000083200011,Firmen und sonstige,Jennifer Schuler,ukb+finanzieren.berater@atpoint.local
// 100214.72,100214-5631,CH1500785001002145631,Firmen und sonstige,Jennifer Schuler,ukb+finanzieren.berater@atpoint.local
// 100214.72,100214-1651,CH9600785001002141651,Firmen und sonstige,Jennifer Schuler,ukb+finanzieren.berater@atpoint.local
// 100248.49,100248-0038,CH7700785001002480038,Private Einzelperson,Sonja Inderkum,ukb+zahlen.sparen@atpoint.local
// 100248.49,100248-49,CH2200785000010024849,Private Einzelperson,Sonja Inderkum,ukb+zahlen.sparen@atpoint.local
// 100248.49,100248-3023,CH8900785001002483023,Private Einzelperson,Sonja Inderkum,ukb+zahlen.sparen@atpoint.local
// 100248.49,100248-8587,CH1700785001002488587,Private Einzelperson,Sonja Inderkum,ukb+zahlen.sparen@atpoint.local
// 100248.49,100248-7788,CH5600785001002487788,Private Einzelperson,Sonja Inderkum,ukb+zahlen.sparen@atpoint.local
// 100250.6,100250-60,CH4800785000010025060,Private Einzelperson,Veronika Arnold,ukb+anlegen.experte@atpoint.local
// 100250.6,100250-0056,CH7500785001002500056,Private Einzelperson,Veronika Arnold,ukb+anlegen.experte@atpoint.local
// 100267.41,100267-0225,CH1400785001002670225,Firmen und sonstige, Team KMU,
// 100270.5,100270-0044,CH9800785001002700044,Private Einzelperson,Fabrizio Merenda,ukb+anlegen.experte@atpoint.local
// 100270.5,812349.71,CH0600785000081234971,Private Einzelperson,Fabrizio Merenda,ukb+anlegen.experte@atpoint.local
// 100270.5,100270-8397,CH9200785001002708397,Private Einzelperson,Fabrizio Merenda,ukb+anlegen.experte@atpoint.local
// 100272.46,100272-0038,CH6500785001002720038,Private Einzelperson,Angela Gehrig,ukb+anlegen.basis@atpoint.local
// 100272.46,806399.26,CH1400785000080639926,Private Einzelperson,Angela Gehrig,ukb+anlegen.basis@atpoint.local
// 100272.46,100272-46,CH0200785000010027246,Private Einzelperson,Angela Gehrig,ukb+anlegen.basis@atpoint.local
// 100272.46,100272-1425,CH5800785001002721425,Private Einzelperson,Angela Gehrig,ukb+anlegen.basis@atpoint.local
// 100272.46,100272-5307,CH0400785001002725307,Private Einzelperson,Angela Gehrig,ukb+anlegen.basis@atpoint.local

import type { PrefixType } from 'atpjs/helpers/i18n'
import type { TranslationType } from 'atpjs/helpers/i18n'

const t = i18n.prefix(['login'])
const tExistingClient = i18n.prefix(['options', 'existingClient'])
const tLoginType = i18n.prefix(['options', 'loginType'])

const swissIbanValidator = (errorMessage: ?TranslationType = null) => {
  return withMessageFn(
    predicate(
      (v: ValueSuccessType) => typeof v === 'string' && isExisty(v) && !isEmpty(v) && VALIDATION.IBAN_REGEX.test(v)
    ),
    (value: string) => reportError({ value }, errorMessage)
  )
}

const contractNumberValidator = (errorMessage: ?TranslationType = null) => {
  return withMessageFn(
    predicate(
      (v: ValueSuccessType) =>
        typeof v === 'string' && isExisty(v) && !isEmpty(v) && VALIDATION.CONTRACT_NUMBER.REGEX.test(v)
    ),
    (value: string) => reportError({ value }, errorMessage)
  )
}

class Login extends Step {
  sendData = false

  constructor(props) {
    super(props)

    this.loginValues = [
      {
        label: tExistingClient(['true']),
        value: 'true',
        icon: 'existing-client-yes'
      },
      {
        label: tExistingClient(['false']),
        value: 'false',
        icon: 'existing-client-no'
      }
    ]

    this.loginTypesValues = [
      {
        label: tLoginType(['iban']),
        value: 'iban'
      },
      {
        label: tLoginType(['contractNumber']),
        value: 'contractNumber'
      }
    ]
  }

  validations(trans: PrefixType) {
    const data = this.getHandler()
    const errorMessage = trans(['contractNumberOrIbanRequired'])

    return {
      login: boolean(),
      ...(data.get('login')
        ? data.get('loginType') === 'iban'
          ? { iban: swissIbanValidator(errorMessage) }
          : { contractNumber: contractNumberValidator(errorMessage) }
        : {})
    }
  }

  handleClientResult = (client) => {
    const data = this.getHandler()
    const customerType = client.getIn(['clientSegment', 'code']) == 'fk' ? 'corporate' : 'private'
    client = client.set('customerType', customerType)

    return data
      .update((data) => {
        return data
          .delete('branch')
          .delete('advisor')
          .delete('clientSegment')
          .merge(client)
      })
      .then(() => 'subject')
  }

  next() {
    const data = this.getHandler()
    if (!data.get('login')) return super.next('customerType')

    const identifier = (
      (data.get('loginType') === 'iban' ? data.get('iban') : data.get('contractNumber')) || ''
    ).replace(/ /g, '')

    return getClient(identifier)
      .then(this.handleClientResult, (_error) => {
        // eslint-disable-next-line
        return data
          .update((data) => {
            return data
              .delete('branch')
              .delete('advisor')
              .delete('clientSegment')
          })
          .then(() => 'customerType')
      })
      .then((nextStep) => {
        return super.next(nextStep)
      })
  }

  render() {
    const inputSetProps = this.inputSetProps()
    const data = this.getHandler()
    const loginType = data.get('loginType')

    return (
      <Application
        title={t(['title'])}
        name={i18n.trans(['tve', 'title'])}
        navigation={<Navigation data={this.getHandler()} next={this.previousHandler} />}>
        <form onSubmit={this.onSubmit}>
          <BigOptionRadio {...inputSetProps(['login'], { label: null })} values={this.loginValues} />
          {this.getData(['login']) && (
            <Fragment>
              <label className="atp-input__name">{i18n.trans(['attributes', 'labels', 'loginType'])}</label>
              <Radio
                {...inputSetProps(['loginType'], { label: false })}
                wrapperClassName="atp-margin-top-xxs"
                values={this.loginTypesValues}
                direction="horizontal"
              />
              {loginType == 'iban' ? (
                <IbanInput {...inputSetProps(['iban'], { label: false })} />
              ) : (
                <TextInput
                  {...inputSetProps(['contractNumber'], { label: false })}
                  minLength={VALIDATION.CONTRACT_NUMBER.MIN_LENGTH}
                  maxLength={VALIDATION.CONTRACT_NUMBER.MAX_LENGTH}
                />
              )}
            </Fragment>
          )}
          <NavigationButtons nextAction={this.nextHandler} />
        </form>
      </Application>
    )
  }
}

export default Login

// <Application title={t(['title'])} name={i18n.trans(['tve', 'title'])}>
//   <form onSubmit={this.onSubmit} ref={this.formElementRef}>
//     <TextInput {...inputSetProps(['firstName'])} />
//     <TextInput {...inputSetProps(['lastName'])} />
//
//     <NavigationButtons nextAction={this.next} previousAction={this.previous} />
//     <button class="atp-btn atp-btn--right-icon atp-btn--icon-add atp-margin-top-xs" onClick={this.nextHandler}></button>
//   </form>
// </Application>
